<header class="flex items-center justify-between px-6 lg:px-32 py-2 bg-white">
  <div class="flex items-center">
    @if (courtService.court().images.length > 0) {
      <img
        [src]="courtService.court().images[0].file"
        alt="Court Logo"
        class="h-10 w-10 lg:h-14 lg:w-14 mr-2" />
    }
    @if (courtService.court().clerk?.photo) {
      <img
        [src]="courtService.court().clerk?.photo"
        alt="Clerk Photo"
        class="h-10 w-10 lg:h-14 lg:w-14 mr-2" />
    }
    <span class="text-lg lg:text-2xl font-bold text-neutral-950">
      {{ courtService.court().name }}
      @if (courtService.court().clerk?.name) {
        - {{ courtService.court().clerk?.name }}
      }
    </span>
  </div>
  <div class="flex justify-end gap-x-6">
    <ui-button appOpenApplicationSelectModal>
      <div class="flex justify-center gap-x-2">
        <fa-icon [icon]="pencilIcon" />
        Create application
      </div></ui-button
    >

    <button
      (click)="logout()"
      class="flex items-center text-neutral-950 text-sm font-medium cursor-pointer">
      <svg
        width="17"
        height="16"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-1.5">
        <path
          d="M5.34619 7.72019H11.7303L10.263 9.22451L11.2693 10.2308L14.5 7L11.2693 3.76923L10.226 4.77548L11.7303 6.2798H5.34619V7.72019Z"
          fill="#353C40" />
        <path
          d="M7.4899 12.563C6.00577 12.563 4.6125 11.9841 3.5625 10.9341C2.5125 9.88413 1.93702 8.4875 1.93702 7C1.93702 5.51587 2.51587 4.11587 3.5625 3.06587C4.6125 2.01587 6.00577 1.43702 7.4899 1.43702C8.97067 1.43702 10.3606 2.0125 11.4106 3.05913L12.4303 2.03942C12.1442 1.75673 11.8312 1.49423 11.4981 1.25865C10.3168 0.4375 8.93365 0 7.4899 0C3.63654 0 0.5 3.1399 0.5 7C0.5 10.8601 3.63654 14 7.4899 14C8.93365 14 10.3168 13.5625 11.4947 12.738C11.8313 12.5024 12.1409 12.2433 12.4269 11.9572L11.4106 10.9409C10.3639 11.9875 8.97067 12.563 7.4899 12.563ZM13.9617 7.0285L13.9331 6.99997L13.9617 6.97139L13.9902 6.99997L13.9617 7.0285Z"
          fill="#353C40" />
      </svg>
      <span>Logout</span>
    </button>
  </div>
</header>
